import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './fonts/fyodor/truetype/Fyodor-Bold.ttf';
import './fonts/GFSNeohellenic/GFSNeohellenic-Regular.ttf';

ReactDOM.render(<App />, document.getElementById('root'));
